var map = {
	"./images/avatars/0.jpg": "LYZP",
	"./images/avatars/1.jpg": "o121",
	"./images/avatars/2.jpg": "hkPl",
	"./images/avatars/3.jpg": "FL8g",
	"./images/bank_0237.jpg": "d2ce",
	"./images/file-manager/document-preview-1.jpg": "BucY",
	"./images/sales-overview/no-product-image.jpg": "1ORa",
	"./images/sales-overview/product-basics.jpg": "+Qj5",
	"./images/sales-overview/product-order-1.jpg": "u5v3",
	"./images/sales-overview/product-order-2.jpg": "L70J",
	"./images/sales-overview/product-order-3.jpg": "C2lx",
	"./images/sales-overview/product-shoes.jpg": "TIG5",
	"./images/sales-overview/product-sportswear.jpg": "fqCd",
	"./images/sales-overview/product-sweaters.jpg": "/8cB",
	"./images/user-profile/up-user-details-background.jpg": "cKzk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vvha";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.jpg$
// module id = vvha
// module chunks = 3